import { Outlet } from "react-router-dom";
import { Grid } from "@mui/material";
import welcomeImg from "../../assets/images/refund.jpg";
import WelcomeImage from "../../components/Login/WelcomeImage";
import classes from "./welcomelayout.module.css";

function WelcomeLayout() {
  return (
    <div className={classes.container}>
      <Grid container spacing={0}>
        <Grid item md={8} className={classes.image}>
          <WelcomeImage name={"login"} img={welcomeImg} />
        </Grid>
        <Grid item xs={12} md={4} className={classes.login}>
          <Outlet />
        </Grid>
      </Grid>
    </div>
  );
}

export default WelcomeLayout;
